<template>
  <div style="max-width: 100%; margin: auto" >
    <div >
      <div class="ma-auto">
        <div class="d-flex align-center my-4">
          <!-- <h1>1</h1> -->
          <v-btn
              to="/"
              color="transparent"
              elevation="0"
          >
            <img
                src="@/assets/images/icons/chevron-right.svg"
                style="width: 40px"

            />
          </v-btn>
          <h3 style="margin-right: -18px;">تاکسی 133</h3>
        </div>
      </div>

      <div class="responsiveSearchLists page-f">

        <v-dialog v-model="dialog" width="500">

          <v-card style="padding:15px;">
            <div style="width:50px; margin:auto;">
              <img  src="@/assets/images/icons/check-outline.svg" alt="">
            </div>
            <h3 style="text-align: center;">آیا برای تایید این سرویس اطمینان دارید؟</h3>
            <div class="d-flex justify-space-between mt-4">
                                  <v-btn @click="AcceptDriver()" width="48%" color="success">تایید</v-btn>
                                  <v-btn @click="dialog = false" width="48%" color="red" class="white--text">انصراف</v-btn>
            </div>
          </v-card>

        </v-dialog>

        <div v-if="SearchList.length>0">
      <div  v-for="(SearchLists,index) in SearchList" :key="index">

        <div class="ShowTopNavBAr">
          <div style="border-bottom: 1px solid white" class="d-flex justify-space-between pa-4">
            <h4>نوع سرویس:
              <span v-if="SearchLists.user_car_type == 'sedan'" style="color: grey; font-weight: 400">خودروهای سواری</span>
              <span v-if="SearchLists.user_car_type == 'lady'" style="color: grey; font-weight: 400">بانوان</span>
              <span v-if="SearchLists.user_car_type == 'luxury'" style="color: grey; font-weight: 400">خودروهای لوکس</span>
              <span v-if="SearchLists.user_car_type == 'bike'" style="color: grey; font-weight: 400">پیک ها</span>
              <span v-if="SearchLists.user_car_type == 'all'" style="color: grey; font-weight: 400">همه خودرو ها</span>
            </h4>
            <h4>زمان: <span style="color: grey; font-weight: 400">{{SearchLists.service_time}}</span></h4>
          </div>
          <!-- <div style="padding-top: 10px !important; padding-bottom: 10px !important;" class="pa-4">
            <h4 style="text-align: right; font-weight: 500"> نام نام خانوادگی : <span style="font-size: 1rem">{{SearchLists.nickname}}</span></h4>
          </div> -->
        </div>

        <div class="container pa-2">
          <h4 class="ma-3"><span style="color: rgb(183,86,86)">مبدا : </span> <span style="font-weight: 400; padding-right: 5px">{{SearchLists.address}}</span></h4>
          <h4 class="ma-3"><span style="color: rgb(183,86,86)">مقصد 1 : </span> <span style="font-weight: 400; padding-right: 5px">{{SearchLists.destination}}</span></h4>
          <h4 v-if="SearchLists.second_destination != ''" class="ma-3"><span style="color: rgb(183,86,86)">مقصد 2 : </span> <span style="font-weight: 400; padding-right: 5px">{{SearchLists.second_destination}}</span></h4>
        </div>

        <div  style="border-bottom: 1px solid #eee; padding-top: 10px !important; padding-bottom: 10px !important;" class="d-flex justify-right align-center pa-4">
          <img style="height: 30px; padding: 0 10px" src="/app/img/speed.png" alt="speed">
          <span>{{SearchLists.distance}} کیلومتر</span>
          <img style="height: 25px; padding: 0 10px" src="/app/img/icon.png" alt="speed">
          <span>0 الی 10 دقیقه</span>
        </div>

        <div class="container pa-2">
          <h4 class="ma-3">
            کرایه: <span style="color: grey">{{SearchLists.amount}} تومان</span>
          </h4>
        </div>

        <div class="d-flex justify-center ">

          <v-btn @click="clickShowIT(SearchLists)" style="
            width: 50%;
            height: 45px;
            background-color: #00947e;
            color: white;
            margin-left: 10px;
          ">
            <v-row  justify="center">
              <div >
                نمایش در نقشه
              </div>
            </v-row>
          </v-btn>
           <div class="text-center" style="  width: 50%;">
              <v-btn
                  @click="opendialog(SearchLists.service_id)" style="

            background-color: #ff7c7c;
            color: white;
            height: 45px;
            width: 100%;
         ">
                قبول سرویس
              </v-btn>
            </div>

        </div>
      </div>
        </div>
      <div v-if="SearchList.length>0&&loadmore" @click="GetFreeService" class="LoadLazyAdd">
        نمایش بیشتر
      </div>

        <v-row v-if="SearchList.length===0" class="justify-center align-center" style="height:90%">

          <div>
        <v-img
            src="/app/img/notfound.jpg"
            alt="Alt text"
            width="400"
            height="300"
        ></v-img>
          </div>

        </v-row>


      <v-snackbar
          color="red"
          style="z-index: 1050"
          v-model="snackbar"
      >
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snackbar = false"
          >
            بستن
          </v-btn>
        </template>
      </v-snackbar>

      <div style="height: 30px"></div>

      <div :style="BtnShowitToUs" class="AllCloseModal">
        <div @click="clickShowIT" class="TopBoxesAllCloseModalP"></div>
        <div class="AllCloseModalBoxes">
          <div id="map" style="width: 100%; height: 100%" ></div>
          <link rel="stylesheet" href="https://unpkg.com/leaflet-routing-machine@latest/dist/leaflet-routing-machine.css" />
          <link rel = "stylesheet" href = "/app/leaflet/leaflet-search.css"/>
          <link href="/app/leaflet/map/leaflet.fullscreen.css" rel='stylesheet' />
          <link rel="stylesheet" href="/app/leaflet/map/leaflet-routing-machine.css" />
        </div>
      </div>

        <v-bottom-sheet style="z-index: 900" v-model="sheet">
          <v-sheet class="text-center" height="400px">
            <div style="padding: 10px" class="ma-5">

              <p class="text-center ">
                <img src="@/assets/images/cash-icon.png" style="width: 80px;border-radius: 5px">
              </p>
              <h3 class="text-center my-5">مبلغ پرداخت خود را به تومان وارد کنید</h3>
              <h4 class="text-center my-5">اعتبار فعلی شما : {{setState.creditDriver}}</h4>

                <v-form
                    ref="form"
                    lazy-validation
                >



                  <input type="text" v-model="money" class="InputShowToOtherPLayer">


                  <v-btn
                      @click="BtnCharge"
                      color="purple"
                      style="border-radius: 5px; width:100%; text-align: center; height: 50px; color:white; font-size:20px;"
                  >
                    افزایش اعتبار
                  </v-btn>


                </v-form>

            </div>
          </v-sheet>
        </v-bottom-sheet>
      </div>
      
    </div>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import "leaflet/dist/leaflet.css";
import SocketListner from "../components/SocketListner.vue";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
import L from "leaflet";
export default {
  components: {
    SocketListner,
    AndroidGeolocation,
   },
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },

  data(){
      return{
        dropArea:null,
        loadmore:false,
        userBox: '',
        time: '',
        money: '',
        BtnShowitToUs : '',
        setState : '',
        text : 'اعتبار شما کافی نمی باشد',
        SearchList : [],
        sheet: false,
        dialog: false,
        marker1: null,
        marker2: null,
        marker3: null,
        PageShow: 0,
        clientHeight: 0,
        windowTop: 0,
        snackbar: false,
        service_id: '',
      }
  },

  mounted() {
    let self = this;
      self.getInfo();
      self.GetFreeService();
      self.userMethod();
      self.mapCreate();
      self.updateScrollBounds();
      self.dropArea = document.getElementById('drop-area');
      window.addEventListener("scroll", this.onScroll);
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    updateScrollBounds() {
      const {clientHeight} = this.$el;
      this.clientHeight = clientHeight;
      console.log(this.clientHeight)
    },
    clickShowIT(SearchLists) {
      let self = this;
      self.sheet = !self.sheet
      if (self.marker1 != null) {
        self.map.removeLayer(self.marker1);
        self.marker1 = null
      }
      if (self.marker2 != null) {
        self.map.removeLayer(self.marker2);
        self.marker1 = null
      }

      if (self.marker3 != null) {
        self.map.removeLayer(self.marker3);
        self.marker1 = null
      }

      if (self.sheet == true) {
        self.BtnShowitToUs = "display: block;"
        self.mapAction(SearchLists)
      } else {
        self.BtnShowitToUs = "display: none;"
      }
    },
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
    },
    userMethod() {
      fetch(this.baseUrl + '/get-driver-credit?public_token=' + this.userBox.public_token + '&uid=' + this.userBox.uid)
          .then(response => response.json())
          .then(json => {
            let data = json.data;
            this.setState = {
              minCredit: data.driverMinCredit,
              creditDriver: data.realCredit,
              visible: false,
            }
          })
    },
    GetFreeService() {
      this.loadmore=true
      this.PageShow += 1
      fetch(this.baseUrl + '/free-service-list?token=' + this.userBox.token + '&public_token=' + this.userBox.public_token + '&uid=' +  this.userBox.uid + '&page=' + this.PageShow)
          .then(response => response.json())
          .then(json => {
                if (json.msg == "سرویسی یافت نشد"){
                  this.PageShow -= 1
                }else {
                  // this.SearchList=[]
                  // json.data.list.forEach((value) => {
                  //   this.SearchList.push(value)
                  this.SearchList= this.SearchList.concat(json.data.list);
                  // });

                  if (json.data.total_page===this.PageShow){
                    this.loadmore=false
                  }
                }
          })
    },
    mapCreate() {
      let self = this;
      let old_lat = '';
      let old_lng = '';

      // ================== defult lat lng ======================
      let latitud = old_lat !== '' ? old_lat : 35.688428639754235;
      let langtitud = old_lng !== '' ? old_lng : 51.38988018035889;

      // ================== map options ======================
      let mapOptions = {
        center: [latitud, langtitud],
        zoom: 13,
        fullscreenControl: false,
      };


      self.map = new L.map('map', mapOptions); // Creating a map object
      let layer = new L.TileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png'); // Creating a Layer object
      self.map.addLayer(layer); // Adding layer to the map

      this.marker_add = 0;

      // ================== click to send position ======================
      self.BtnShowitToUs = "display: none;"

    },
    mapAction: function (SearchLists) {
      let self = this;
      self.map.setView([SearchLists.origin.lat, SearchLists.origin.lng], 13);

      self.marker1 = new L.Marker([SearchLists.origin.lat, SearchLists.origin.lng], {
        draggable: false,
        icon: new L.DivIcon({
          iconAnchor: [-7, 55],
          elevation: 0,
          title: "مکان",
          className: 'my-div-icon',
          html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker1.png" width="60px"/>' +
              '<span class="my-div-span busy"></span></div>',
        })
      });
      self.marker1.addTo(self.map);
      self.marker1.on('dragend', function () {
        let coord = self.marker1.getLatLng();
        let lat = coord.lat;
        let lng = coord.lng;
        self.param.latitude = lat;
        self.param.longitude = lng;
      });

      self.marker2 = new L.Marker([SearchLists.destination_arr.lat, SearchLists.destination_arr.lng], {
        draggable: false,
        icon: new L.DivIcon({
          iconAnchor: [-7, 55],
          elevation: 0,
          title: "مکان",
          className: 'my-div-icon',
          html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker2.png" width="60px"/>' +
              '<span class="my-div-span busy"></span></div>',
        })
      });
      self.marker2.addTo(self.map);
      self.marker2.on('dragend', function () {
        let coord = self.marker2.getLatLng();
        let lat = coord.lat;
        let lng = coord.lng;
        self.param.latitude = lat;
        self.param.longitude = lng;
      });

      if (SearchLists.second_destination_arr.lat != "") {
        self.marker3 = new L.Marker([SearchLists.second_destination_arr.lat, SearchLists.second_destination_arr.lng], {
          draggable: false,
          icon: new L.DivIcon({
            iconAnchor: [-7, 55],
            elevation: 0,
            title: "مکان",
            className: 'my-div-icon',
            html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker3.png" width="60px"/>' +
                '<span class="my-div-span busy"></span></div>',
          })
        });
        self.marker3.addTo(self.map);
        self.marker3.on('dragend', function () {
          let coord = self.marker3.getLatLng();
          let lat = coord.lat;
          let lng = coord.lng;
          self.param.latitude = lat;
          self.param.longitude = lng;
        });
      }
    },
    async AcceptDriver() {
      let self=this;
      // if (this.setState.minCredit <=  this.setState.creditDriver){
        let response = await fetch(this.baseUrl + '/accept-free-service', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            service_id: this.service_id,
            uid: this.userBox.uid,
            public_token: this.userBox.public_token
          })
        });
        let json = await response.json();
      console.log('myss',json)
      if (json.result==='1')
      {
        self.$router.push({
          name: 'currentservice',
          params: {
            obj: {...json.data}
          }
        })

      }

      if (json.result==='0'){
        this.snackbar = true;
        this.text=json.msg;
        this.dialog = false


      }

      // }else {
      //   this.snackbar = true
      //
      //
      // }


    },

    async BtnCharge() {
        var price = this.money.split(',').join('');
        if (this.money == '') {
          this.snackbar = true
          this.text = 'مبلغ مورد نظر را وارد کنید'
        } else {
          let response = await fetch(this.baseUrl + '/charge-driver-credit', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              public_token: this.userBox.public_token,
              uid: "279",
              price: price,
            })
          });
          let json = await response.json();
          this.setState({ BtnDisable: false });

          if (json.result === 1) {
            // var RedirectURL = json.data.RedirectURL;
            // var action = json.data.action;
            var token = json.data.token;
            var url = this.baseUrl + "/SepPay?token=" + token;
            window.location.href = url;
          } else if (json.result === 0) {
            // Validate
          }
        }
    },

    opendialog(service_id){
      this.dialog=true;
      this.service_id=service_id;
    }

  }
};
</script>

<style scoped>

.InputShowToOtherPLayer{
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  height: 50px;
  margin-bottom: 20px;
  border: 1px solid #e3e3e3;
}

.AllCloseModal{
  position: fixed;
  top:0;
  display: block;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.30);
  z-index: 1050;
}

.TopBoxesAllCloseModalP{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 20%;
  cursor: pointer;
}

.AllCloseModalBoxes{
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 80%;
  background: white;
  overflow: hidden;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.ShowTopNavBAr{
  border-radius: 10px;
  background: rgba(255, 202, 40, 0.5) !important;
  margin-top: 30px;
  box-shadow: 0 0 2px rgba(0,0,0,.2);
}

@media only screen and (max-width: 600px) {
  .responsiveSearchLists{
    padding: 0 10px;
  }
}

.LoadLazyAdd{
  margin: auto;
  width: 50%;
  height: 40px;
  border-radius: 30px;
  text-align: center;
  background: rgb(86, 146, 183);
  margin-top: 30px;
  line-height: 38px;
  color: white;
  cursor: pointer;
}
.page-f{

  height: calc(100vh - 116px);
  overflow: auto;

}
</style>
